
// import React, { useEffect, useState } from "react";
// import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// import { supabase } from "./lib/supabase";

// import "antd/dist/reset.css";

// import AnnouncementBar from "./components/AnnouncementBar";
// import Header from "./components/Header";
// import Hero from "./components/Hero";
// import Content from "./components/Content";
// import Method from "./components/Method";
// import Research from "./components/Research";
// import SeriesIntro from "./components/SeriesIntro";
// import SeriesAccess from "./components/SeriesAccess";
// import DataVisualizer from "./components/DataVisualizer";
// import Footer from "./components/Footer";

// import Data from "./components/Data";
// import Login from "./components/Login";
// import EmbedChart from "./components/EmbedChart";


// /* =========================================================
//    HOME PAGE
//    ========================================================= */

// function Home() {
//   return (
//     <>
//       <AnnouncementBar />

//       <main id="top" className="content-inner">

//         <Header />

//         <Hero />

//         <Content />

//         <Method />

//         <SeriesIntro />

//         <DataVisualizer />

//         <SeriesAccess />

//         <Research />

//       </main>

//       <Footer />
//     </>
//   );
// }


// /* =========================================================
//    APP
//    ========================================================= */

// function App() {

//   const [user, setUser] = useState(null);
//   const [authLoading, setAuthLoading] = useState(true);


//   /* =========================================================
//      SUPABASE SESSION
//      ========================================================= */

//   useEffect(() => {

//     let mounted = true;


//     const getSession = async () => {

//       const {
//         data: { session },
//       } = await supabase.auth.getSession();


//       if (mounted) {

//         setUser(session?.user ?? null);

//         setAuthLoading(false);

//       }

//     };


//     getSession();


//     const {
//       data: { subscription },
//     } = supabase.auth.onAuthStateChange(
//       (_event, session) => {

//         if (mounted) {

//           setUser(session?.user ?? null);

//         }

//       }
//     );


//     return () => {

//       mounted = false;

//       subscription.unsubscribe();

//     };

//   }, []);


//   /* =========================================================
//      AUTH LOADING
//      ========================================================= */

//   if (authLoading) {

//     return (
//       <div
//         style={{
//           minHeight: "100vh",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           fontFamily: "Inter, sans-serif",
//         }}
//       >
//         Loading...
//       </div>
//     );

//   }


//   return (
//     <BrowserRouter>

//       <Routes>


//         {/* =================================================
//             DEFAULT URL

//             https://epu-index.pl/

//             → /login
//             ================================================= */}

//         <Route
//           path="/"
//           element={
//             user
//               ? <Home />
//               : <Navigate to="/login" replace />
//           }
//         />


//         {/* =================================================
//             LOGIN

//             https://epu-index.pl/login
//             ================================================= */}

//         <Route
//           path="/login"
//           element={
//             user
//               ? <Navigate to="/" replace />
//               : (
//                 <Login
//                   onLogin={() => {

//                     /*
//                      * Login.jsx has already authenticated
//                      * the user through Supabase.
//                      *
//                      * Supabase's onAuthStateChange will
//                      * update `user`, causing this route
//                      * to redirect to "/".
//                      */

//                   }}
//                 />
//               )
//           }
//         />


//         {/* =================================================
//             DATA PAGE

//             https://epu-index.pl/data
//             ================================================= */}

//         <Route
//           path="/data"
//           element={
//             user
//               ? <Data />
//               : <Navigate to="/login" replace />
//           }
//         />


//         {/* =================================================
//             EMBED CHART

//             https://epu-index.pl/embed/chart

//             This remains accessible without login.
//             ================================================= */}

//         <Route
//           path="/embed/chart"
//           element={<EmbedChart />}
//         />


//         {/* =================================================
//             FALLBACK

//             Any unknown URL → login
//             ================================================= */}

//         <Route
//           path="*"
//           element={
//             <Navigate
//               to={user ? "/" : "/login"}
//               replace
//             />
//           }
//         />


//       </Routes>

//     </BrowserRouter>
//   );
// }


// export default App;

import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import "antd/dist/reset.css";

import AnnouncementBar from "./components/AnnouncementBar";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Content from "./components/Content";
import Method from "./components/Method";
import Research from "./components/Research";
import SeriesIntro from "./components/SeriesIntro";
import SeriesAccess from "./components/SeriesAccess";
import DataVisualizer from "./components/DataVisualizer";
import Footer from "./components/Footer";

import Data from "./components/Data";
import EmbedChart from "./components/EmbedChart";


/* =========================================================
   HOME PAGE
   ========================================================= */

function Home() {
  return (
    <>
      <AnnouncementBar />

      <main id="top" className="content-inner">

        <Header />

        <Hero />

        <Content />

        <Method />

        <SeriesIntro />

        <DataVisualizer />

        <SeriesAccess />

        <Research />

      </main>

      <Footer />
    </>
  );
}


/* =========================================================
   APP
   ========================================================= */

function App() {
  return (
    <BrowserRouter>

      <Routes>

        {/* https://epu-index.pl/ */}
        <Route path="/" element={<Home />} />

        {/* https://epu-index.pl/data */}
        <Route path="/data" element={<Data />} />

        {/* https://epu-index.pl/embed/chart — public embed */}
        <Route path="/embed/chart" element={<EmbedChart />} />

        {/* Fallback: any unknown URL → home */}
        <Route path="*" element={<Navigate to="/" replace />} />

      </Routes>

    </BrowserRouter>
  );
}


export default App;